import { compose } from "app/utils";
import React from "react";
import * as validate from "app/validate";
import * as forms from "app/forms";
import { injectIntl } from "react-intl";

const enhance = compose(
  forms.reduxField,
  forms.interactive,
  forms.labelled
);

const unlabelledEnhance = compose(
  forms.reduxField,
  forms.interactive,
  forms.unlabelled
);
const InputField = enhance(forms.CustomInputGroup);
const PasswordField = enhance(forms.PasswordField);
const CheckboxField = unlabelledEnhance(forms.CheckboxField);

export const ScreenName = injectIntl(props => (
  <InputField
    type="text"
    label={props.intl.formatMessage({
      id: "auth.user.screenname",
      defaultMessage: "Screen name"
    })}
    {...props}
    name="screenName"
    validate={value => {
      if (!value) return undefined;

      return value.length == 0 || value.length >= 4
        ? undefined
        : "Screen name must be more than 4 characters long";
    }}
  />
));

export const Email = injectIntl(props => (
  <InputField
    type="text"
    label={props.intl.formatMessage({
      id: "auth.user.email",
      defaultMessage: "Email"
    })}
    validate={[validate.required]}
    {...props}
    name="email"
  />
));

export const Password = injectIntl(props => (
  <PasswordField
    label={props.intl.formatMessage({
      id: "auth.password",
      defaultMessage: "Password"
    })}
    validate={validate.required}
    {...props}
    name="password"
  />
));

export const FullName = injectIntl(props => (
  <InputField
    type="text"
    label={props.intl.formatMessage({
      id: "auth.fullname",
      defaultMessage: "Full name"
    })}
    {...props}
    name="fullName"
  />
));

export const AcceptPrivacyNotice = injectIntl(props => (
  <CheckboxField
    label="*Please check this to accept the privacy notice..."
    name="acceptPrivacyNotice"
  />
));



// WEBPACK FOOTER //
// ./src/app/auth/fields.js